import { CSSProperties, SVGProps } from 'react'

interface LinkedInPlatformIconProps extends SVGProps<SVGSVGElement> {
    className?: string
    style?: CSSProperties
    color?: string
    size?: number
    onClick?: () => void
}

/**
 * LinkedIn platform icon component
 */
const LinkedInPlatformIcon = ({
    className,
    style,
    color = 'white',
    size = 92,
    onClick,
}: LinkedInPlatformIconProps) => (
    <svg
        className={className}
        style={style}
        width={size}
        height={size * (40 / 92)}
        onClick={onClick}
        viewBox="0 0 92 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0_453_226)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M84.5514 10H67.5076C66.6924 10 66 10.6448 66 11.439V28.56C66 29.3552 66.4543 30 67.2695 30H84.3133C85.1295 30 86 29.3552 86 28.56V11.439C86 10.6448 85.3676 10 84.5514 10ZM73.619 17.619H76.3114V18.9914H76.341C76.7514 18.2514 77.9638 17.5 79.4629 17.5C82.34 17.5 83.1429 19.0276 83.1429 21.8571V27.1429H80.2857V22.3781C80.2857 21.1114 79.78 20 78.5971 20C77.1609 20 76.4762 20.9724 76.4762 22.5686V27.1429H73.619V17.619ZM68.8571 27.1429H71.7143V17.619H68.8571V27.1429ZM72.0714 14.2857C72.0715 14.5202 72.0255 14.7524 71.9358 14.969C71.8462 15.1857 71.7147 15.3826 71.549 15.5484C71.3833 15.7143 71.1865 15.8459 70.9699 15.9357C70.7533 16.0255 70.5211 16.0717 70.2867 16.0718C70.0522 16.0718 69.82 16.0257 69.6034 15.936C69.3867 15.8463 69.1899 15.7149 69.0241 15.5491C68.8582 15.3833 68.7267 15.1865 68.6369 14.9699C68.5472 14.7533 68.501 14.5211 68.501 14.2867C68.5009 13.8132 68.6889 13.3592 69.0236 13.0244C69.3583 12.6896 69.8123 12.5014 70.2857 12.5013C70.7591 12.5012 71.2132 12.6891 71.5481 13.0237C71.883 13.3584 72.0712 13.8123 72.0714 14.2857Z"
                fill={color}
            />
            <path
                d="M63.1428 27.1429H60.4762V26.0086H60.4476C59.8543 26.6962 58.8238 27.2619 57.0771 27.2619C54.6962 27.2619 52.6457 25.4705 52.6457 22.3914C52.6457 19.4581 54.6666 17.5 57.1666 17.5C58.7143 17.5 59.6752 18.0505 60.2571 18.7533H60.2857V12.8571H63.1428V27.1429ZM57.8847 19.6429C56.2514 19.6429 55.3333 20.8076 55.3333 22.3562C55.3333 23.9057 56.2514 25.1191 57.8847 25.1191C59.52 25.1191 60.4762 23.9371 60.4762 22.3562C60.4762 20.7314 59.52 19.6429 57.8847 19.6429ZM51.3914 25.6086C50.7171 26.4819 49.3285 27.2619 47.0866 27.2619C44.0962 27.2619 42.1914 25.281 42.1914 22.1695C42.1914 19.4048 43.9162 17.5 47.1705 17.5C49.9809 17.5 51.7143 19.3457 51.7143 22.5924C51.7143 22.9162 51.6619 23.2381 51.6619 23.2381H44.8866L44.9028 23.5324C45.0905 24.3533 45.7105 25.3571 47.1333 25.3571C48.3752 25.3571 49.2266 24.6895 49.6114 24.1667L51.3914 25.6086ZM48.9647 21.4276C48.9838 20.4238 48.2466 19.4048 47.0847 19.4048C45.7019 19.4048 44.9638 20.4848 44.8866 21.4286H48.9647V21.4276Z"
                fill={color}
            />
            <path
                d="M42.1905 17.619H38.8571L35.5238 21.4286V12.8571H32.6667V27.1428H35.5238V22.3809L39.0467 27.1428H42.42L38.381 21.9362L42.1905 17.619ZM21.2381 17.619H23.9305V18.9914H23.96C24.3705 18.2514 25.5829 17.5 27.0819 17.5C29.959 17.5 30.7619 19.3257 30.7619 21.8571V27.1428H27.9048V22.3781C27.9048 20.9762 27.399 20 26.2162 20C24.78 20 24.0952 21.1371 24.0952 22.5686V27.1428H21.2381V17.619ZM16.4762 27.1428H19.3333V17.619H16.4762V27.1428ZM17.9057 16C18.1342 16.0054 18.3614 15.965 18.574 15.8813C18.7867 15.7976 18.9804 15.6722 19.1439 15.5126C19.3074 15.3529 19.4373 15.1621 19.526 14.9515C19.6147 14.7409 19.6604 14.5147 19.6604 14.2862C19.6604 14.0577 19.6147 13.8314 19.526 13.6208C19.4373 13.4102 19.3074 13.2195 19.1439 13.0598C18.9804 12.9001 18.7867 12.7747 18.574 12.691C18.3614 12.6073 18.1342 12.567 17.9057 12.5724C17.4582 12.5829 17.0325 12.7681 16.7197 13.0884C16.4069 13.4086 16.2318 13.8385 16.2318 14.2862C16.2318 14.7338 16.4069 15.1637 16.7197 15.484C17.0325 15.8042 17.4582 15.9894 17.9057 16ZM8.85714 12.8571H6V27.1428H14.5714V24.2857H8.85714V12.8571Z"
                fill={color}
            />
        </g>
        <defs>
            <clipPath id="clip0_453_226">
                <rect width="80" height="20" fill="white" transform="translate(6 10)" />
            </clipPath>
        </defs>
    </svg>
)

export default LinkedInPlatformIcon
